








































































































import { Component, Vue } from 'vue-property-decorator';
import { InvoiceListModule } from '@/store/modules/invoiceList';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AppModule } from '@/store/modules/app';
import ListUtils from '@/lib/listUtils';

@Component({
  name: 'InvoiceListSearchCriteria',
})
export default class extends GiganautVueDialog {

  async mounted() {
    await InvoiceListModule.getCompaniesForSearchOptions();
  }

  // allowedDates(date: Date) {
  //   return new Date(date).getDay() === 1;
  // }

  get searchOptions() {
    return InvoiceListModule.invoiceSearchViewModel;
  }

  get companies() {
    return InvoiceListModule.invoiceSearchViewModel.companies;
  }

  get branches() {
    return InvoiceListModule.invoiceSearchViewModel.branches;
  }

  get Labels() {
    return AppModule.currentAgencyContext.labels;
  }

  get statusOptions() {
    return ListUtils.invoiceStatuses();
  }

  get typeOptions() {
    return ListUtils.invoiceTypes();
  }

  async search() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await InvoiceListModule.searchInvoices();
    this.dialog = false;
  }
}
